export const areAllTicketsSentToBuyerEmail = (order: wix.events.ticketing.Order) => {
  const {email: buyerEmail, tickets} = order

  return tickets.every(({guestDetails: {email}}) => email === buyerEmail)
}
